/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VmcDailyOrgSummaryResponse } from './vmcDailyOrgSummaryResponse';


export interface VmcDailyOrgSummaryBulkResponse { 
    vmc_daily_org_summary_usages?: Array<VmcDailyOrgSummaryResponse>;
    total_record_count?: number;
}

